import { createApi } from '@reduxjs/toolkit/query/react'
import baseQueryWithReauth from './baseQueryWithReauth';

// Define a service using a base URL and expected endpoints
export const lookupApi = createApi({
  reducerPath: 'lookupApi',  
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    equipment: builder.query<any, void>({
      query: () => 'equipment',
    })
  }),  
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useEquipmentQuery } = lookupApi;